/** ラッパーが挟まる DOM 構造変更に強くするため、className ではなく computed style で判定する */
export function findScrollableAncestor(
  element: HTMLElement,
): HTMLElement | null {
  let current = element.parentElement;
  while (current !== null) {
    const { overflowY } = getComputedStyle(current);
    if (overflowY === "auto" || overflowY === "scroll") {
      return current;
    }
    current = current.parentElement;
  }
  return null;
}
